import { Button, Checkbox, Divider, Form, Input, Radio, Select } from 'antd'
import dayjs from 'dayjs'
import React, { useContext, useEffect, useState } from 'react'
import GlobalContext from '../GlobalContext'
import { post } from '../../Common/api'
import { useForm } from 'antd/es/form/Form'
import { t } from 'i18next'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'

export default function FeedbackForm ({ slot, setSlot, setLoading, formStyle, setIsDirty }) {
  const [form] = useForm()
  const [choicesValues, setChoicesValues] = useState({})
  const [question0Answer, setQuestion0Answer] = useState()
  const [question1Answer, setQuestion1Answer] = useState()
  const [question4Answer, setQuestion4Answer] = useState()
  const [question7Answer, setQuestion7Answer] = useState()
  const [question9Answer, setQuestion9Answer] = useState()
  const [question10Answer, setQuestion10Answer] = useState()
  const [otherOnChange, setOtherOnChange] = useState({})
  const { user } = useContext(GlobalContext)
  const [initialValues, setInitialValues] = useState()
  const feedbackAlreadyCreated = slot.feedback.find((e) => e.question.order === 0).answers.length > 0
  const screens = useBreakpoint()
  const { notificationApi } = useContext(GlobalContext)

  const userFeedbackOnChange = (value, name, updateValue) => {
    form.setFieldValue(name, value)
    updateValue(value)
    setIsDirty && setIsDirty(true)
    if (value !== 'Satisfait') {
      setQuestion9Answer('Oui')
      form.setFieldValue('9', 'Oui')
    }
  }

  const singleChoiceOnChange = (value, name, updateValue) => {
    form.setFieldValue(name, value)
    updateValue(value)
    setIsDirty && setIsDirty(true)
  }

  const labelCol = screens.xl ? { span: 8 } : { span: 6 }
  const style = {
    singleChoice: { display: 'flex', flexDirection: 'column', gap: 8 },
    multipleChoice: { display: 'flex', flexDirection: 'column', gap: 8 }
  }
  const capitalize = (value) => (value.charAt(0).toUpperCase() + value.slice(1))

  const defaultQuestion6answer = () => {
    if (!slot.reel_end_date) {
      return undefined
    }
    const diff = dayjs(slot.reel_end_date).diff(dayjs(slot.reel_start_date), 'm')
    if (diff < 10) {
      return '<10'
    } else if (diff > 70) {
      return '70<'
    } else {
      return slot.feedback[7].question.choices.find((choice) => diff.toString().charAt(0) === choice.charAt(0))
    }
  }

  const defaultValues = {
    2: capitalize(dayjs(slot.begin_date).format('dddd')),
    3: `${dayjs(slot.begin_date).hour()}-${dayjs(slot.begin_date).add(1, 'hour').hour()}h`,
    5: defaultQuestion6answer(),
    7: 'Satisfait',
    9: 'Non',
    11: `${slot.booked_slots.count} fois`
  }

  const singleAnswerFormatting = (params, values, index, feedback) => {
    const value = values[index] === 'Autre' ? values[`${index}_other`] : values[index]
    if (feedback.answers.length > 0) {
      updateExistingAnswer(params, feedback.answers[0], value)
    } else if (value !== undefined) {
      addNewAnswer(params, values[`${index}_id`], value)
    }
  }

  const multipleAnswerFormatting = (params, values, index, feedback) => {
    if (values[index]) {
      feedback.answers.forEach((answer) => {
        if (values[index].includes(answer.value)) {
          keepExistingAnswer(params, answer)
        } else {
          destroyExistingAnswer(params, answer)
        }
      })
      values[index].forEach((value) => {
        if (!params.feedback_answers_attributes.map((e) => e.value).includes(value)) {
          value = value === 'Autre' ? values[`${index}_other`] : value
          addNewAnswer(params, values[`${index}_id`], value)
        }
      })
    } else {
      feedback.answers.forEach((answer) => {
        destroyExistingAnswer(params, answer)
      })
    }
  }

  const keepExistingAnswer = (params, answer) => {
    params.feedback_answers_attributes.push(answer)
  }

  const updateExistingAnswer = (params, answer, value) => {
    params.feedback_answers_attributes.push({ ...answer, value })
  }

  const addNewAnswer = (params, questionId, value) => {
    params.feedback_answers_attributes.push({
      feedback_question_id: questionId,
      user_id: user.id,
      value
    })
  }

  const destroyExistingAnswer = (params, answer) => {
    params.feedback_answers_attributes.push({ ...answer, _destroy: 1 })
  }

  const onFinish = (values) => {
    const params = { feedback_answers_attributes: [] }
    for (let index = 0; index < slot.feedback.length; index++) {
      const feedback = slot.feedback.find((e) => e.question.order === index)
      console.log(feedback.question)
      console.log(values)
      if (feedback.question.field_type !== 'multiple_choice') {
        singleAnswerFormatting(params, values, index, feedback)
      } else {
        multipleAnswerFormatting(params, values, index, feedback)
      }
    }
    saveFeedback(params)
  }

  const saveFeedback = (params) => {
    setLoading(true)
    post({
      url: `admin/slots/${slot.id}/update_feedback`,
      params,
      notification: { api: notificationApi, state: 'update' },
      onSuccess: (response) => {
        setLoading(false)
        setIsDirty && setIsDirty(false)
        setSlot({ ...slot, feedback: response.feedback })
      },
      onFailure: (_) => {
        setLoading(false)
      }
    })
  }

  const setSingleDefaultValues = (defaultValues, choices) => {
    slot.feedback.filter((f) => f.question.field_type !== 'multiple_choice').forEach((f) => {
      if (feedbackAlreadyCreated && f.answers.length > 0) {
        setSingleDefaultValuesWithCreatedAnswers(f, defaultValues, choices)
      }
      defaultValues[`${f.question.order}_id`] = f.question.id
    })
  }

  const setSingleDefaultValuesWithCreatedAnswers = (f, defaultValues, choices) => {
    if (f.question.field_type === 'date') {
      defaultValues[f.question.order] = dayjs(f.answers[0].value)
    } else if (f.question.field_type === 'single_choice' && !f.question.choices.includes(f.answers[0].value)) {
      defaultValues[f.question.order] = 'Autre'
      defaultValues[`${f.question.order}_other`] = f.answers[0].value
      choices[f.question.order] = 'Autre'
    } else {
      defaultValues[f.question.order] = f.answers[0].value
    }
  }

  const setMultipleDefaultValues = (defaultValues, choices, methods) => {
    slot.feedback.filter((f) => f.question.field_type === 'multiple_choice').forEach((f) => {
      if (feedbackAlreadyCreated) {
        setMultipleDefaultValuesWithCreatedAnswers(f, defaultValues, choices)
      }
      defaultValues[`${f.question.order}_id`] = f.question.id
      methods[f.question.order] = (values, choices) => {
        const currentValues = { ...choices }
        currentValues[f.question.order] = values
        setChoicesValues(currentValues)
      }
    })
  }

  const setMultipleDefaultValuesWithCreatedAnswers = (f, defaultValues, choices) => {
    defaultValues[f.question.order] = []
    f.answers.forEach((answer) => {
      if (!f.question.choices.includes(answer.value)) {
        defaultValues[f.question.order].push('Autre')
        defaultValues[`${f.question.order}_other`] = answer.value
        choices[f.question.order] = 'Autre'
      } else {
        defaultValues[f.question.order].push(answer.value)
      }
    })
  }

  useEffect(() => {
    const choices = {}
    const methods = {}
    setSingleDefaultValues(defaultValues, choices)
    setMultipleDefaultValues(defaultValues, choices, methods)
    methods.single = (value, name, updateValue, choices) => {
      const currentValues = { ...choices }
      currentValues[name] = value
      setChoicesValues(currentValues)
      form.setFieldValue(name, value)
      updateValue(value)
      setIsDirty && setIsDirty(true)
    }
    setQuestion0Answer(defaultValues[0])
    setQuestion1Answer(defaultValues[1])
    setQuestion4Answer(defaultValues[4])
    setQuestion7Answer(defaultValues[7])
    setQuestion9Answer(defaultValues[9])
    setQuestion10Answer(defaultValues[10])
    setInitialValues(defaultValues)
    setChoicesValues(choices)
    setOtherOnChange(methods)
  }, [slot])

  return (
    <>
      { initialValues &&
        <Form form={form} onFinish={onFinish} initialValues={initialValues} style={formStyle} labelWrap onValuesChange={() => setIsDirty && setIsDirty(true)}>
          <Form.Item label={slot.feedback[0].question.value} labelCol={labelCol} wrapperCol={{ span: 12 }} >
            <Radio.Group options={slot.feedback[0].question.choices} style={style.singleChoice}
              onChange={({ target: { value } }) => otherOnChange.single(value, slot.feedback[0].question.order, setQuestion0Answer, choicesValues)}
              value={question0Answer}
            />
          </Form.Item>
          <Form.Item name={`${slot.feedback[0].question.order}`} hidden><Input /></Form.Item>
          <Form.Item name={`${slot.feedback[0].question.order}_id`} hidden><Input /></Form.Item>
          <Form.Item name={`${slot.feedback[0].question.order}_other`} wrapperCol={{ span: 12, offset: 8 }} hidden={choicesValues[slot.feedback[0].question.order] !== 'Autre'}><Input /></Form.Item>
          <Divider style={{ minWidth: '50%', width: '50%', margin: '24px 25%' }} />

          <Form.Item label={slot.feedback[1].question.value} labelCol={labelCol} wrapperCol={{ span: 12 }} >
            <Radio.Group options={slot.feedback[1].question.choices} style={style.singleChoice}
              onChange={({ target: { value } }) => singleChoiceOnChange(value, slot.feedback[1].question.order, setQuestion1Answer)}
              value={question1Answer}
            />
          </Form.Item>
          <Form.Item name={`${slot.feedback[1].question.order}`} hidden><Input /></Form.Item>
          <Form.Item name={`${slot.feedback[1].question.order}_id`} hidden><Input /></Form.Item>
          <Divider style={{ minWidth: '50%', width: '50%', margin: '24px 25%' }} />

          <Form.Item name={2} label={slot.feedback[2].question.value} labelCol={labelCol} wrapperCol={{ span: 12 }} >
            <Select options={slot.feedback[2].question.choices.map((o) => ({ label: o, value: o }))} />
          </Form.Item>
          <Form.Item name={`${slot.feedback[2].question.order}_id`} hidden><Input /></Form.Item>
          <Divider style={{ minWidth: '50%', width: '50%', margin: '24px 25%' }} />

          <Form.Item name={3} label={slot.feedback[3].question.value} labelCol={labelCol} wrapperCol={{ span: 12 }} >
            <Select options={slot.feedback[3].question.choices.map((o) => ({ label: o, value: o }))} />
          </Form.Item>
          <Form.Item name={`${slot.feedback[3].question.order}_id`} hidden><Input /></Form.Item>
          <Divider style={{ minWidth: '50%', width: '50%', margin: '24px 25%' }} />

          <Form.Item label={slot.feedback[4].question.value} labelCol={labelCol} wrapperCol={{ span: 12 }} >
            <Radio.Group options={slot.feedback[4].question.choices} style={style.singleChoice}
              onChange={({ target: { value } }) => singleChoiceOnChange(value, slot.feedback[4].question.order, setQuestion4Answer)}
              value={question4Answer}
            />
          </Form.Item>
          <Form.Item name={`${slot.feedback[4].question.order}`} hidden><Input /></Form.Item>
          <Form.Item name={`${slot.feedback[4].question.order}_id`} hidden><Input /></Form.Item>
          <Divider style={{ minWidth: '50%', width: '50%', margin: '24px 25%' }} />

          <Form.Item name={5} label={slot.feedback[5].question.value} labelCol={labelCol} wrapperCol={{ span: 12 }} >
            <Select options={slot.feedback[5].question.choices.map((o) => ({ label: o, value: o }))} />
          </Form.Item>
          <Form.Item name={`${slot.feedback[5].question.order}_id`} hidden><Input /></Form.Item>
          <Divider style={{ minWidth: '50%', width: '50%', margin: '24px 25%' }} />

          <Form.Item name={6} label={slot.feedback[6].question.value} labelCol={labelCol} wrapperCol={{ span: 12 }} >
            <Checkbox.Group options={slot.feedback[6].question.choices} style={style.multipleChoice} />
          </Form.Item>
          <Form.Item name={`${slot.feedback[6].question.order}_id`} hidden><Input /></Form.Item>
          <Divider style={{ minWidth: '50%', width: '50%', margin: '24px 25%' }} />

          <Form.Item label={slot.feedback[7].question.value} labelCol={labelCol} wrapperCol={{ span: 12 }} >
            <Radio.Group options={slot.feedback[7].question.choices} style={style.singleChoice}
              onChange={({ target: { value } }) => userFeedbackOnChange(value, slot.feedback[7].question.order, setQuestion7Answer)}
              value={question7Answer}
            />
          </Form.Item>
          <Form.Item name={`${slot.feedback[7].question.order}`} hidden><Input /></Form.Item>
          <Form.Item name={`${slot.feedback[7].question.order}_id`} hidden><Input /></Form.Item>
          <Divider style={{ minWidth: '50%', width: '50%', margin: '24px 25%' }} />

          <Form.Item name={8} label={slot.feedback[8].question.value} labelCol={labelCol} wrapperCol={{ span: 12 }} >
            <Input />
          </Form.Item>
          <Form.Item name={`${slot.feedback[8].question.order}_id`} hidden><Input /></Form.Item>
          <Divider style={{ minWidth: '50%', width: '50%', margin: '24px 25%' }} />

          <Form.Item label={slot.feedback[9].question.value} labelCol={labelCol} wrapperCol={{ span: 12 }} >
            <Radio.Group options={slot.feedback[9].question.choices} style={style.singleChoice}
              onChange={({ target: { value } }) => singleChoiceOnChange(value, slot.feedback[9].question.order, setQuestion9Answer)}
              value={question9Answer}
            />
          </Form.Item>
          <Form.Item name={`${slot.feedback[9].question.order}`} hidden><Input /></Form.Item>
          <Form.Item name={`${slot.feedback[9].question.order}_id`} hidden><Input /></Form.Item>
          <Divider style={{ minWidth: '50%', width: '50%', margin: '24px 25%' }} />

          <Form.Item label={slot.feedback[10].question.value} labelCol={labelCol} wrapperCol={{ span: 12 }} >
            <Radio.Group options={slot.feedback[10].question.choices} style={style.singleChoice}
              onChange={({ target: { value } }) => otherOnChange.single(value, slot.feedback[10].question.order, setQuestion10Answer, choicesValues)}
              value={question10Answer}
            />
          </Form.Item>
          <Form.Item name={`${slot.feedback[10].question.order}`} hidden><Input /></Form.Item>
          <Form.Item name={`${slot.feedback[10].question.order}_id`} hidden><Input /></Form.Item>
          <Form.Item name={`${slot.feedback[10].question.order}_other`} wrapperCol={{ span: 12, offset: 8 }} hidden={choicesValues[slot.feedback[10].question.order] !== 'Autre'}><Input /></Form.Item>
          <Divider style={{ minWidth: '50%', width: '50%', margin: '24px 25%' }} />

          <Form.Item name={11} label={slot.feedback[11].question.value} labelCol={labelCol} wrapperCol={{ span: 12 }} >
            <Input />
          </Form.Item>
          <Form.Item name={`${slot.feedback[11].question.order}_id`} hidden><Input /></Form.Item>
          <Divider style={{ minWidth: '50%', width: '50%', margin: '24px 25%' }} />

          <Button type="primary" style={{ float: 'right', marginRight: '4em' }} htmlType='submit' disabled={slot.is_cancel}>
            {t('Admin.btn.save')}
          </Button>
        </Form>
      }
    </>
  )
}
